import * as React from "react";
import PropTypes from 'prop-types';
import { FieldTable } from "../../../components/FieldTable/FieldTable";
import { format, addWeeks, parse } from 'date-fns';
import { AreaBookingItem, useGetAreaBookingRegionPricingsQuery } from "../../../generated/graphql";
import { FieldTableColumnProps } from '../../../components/FieldTable/FieldTableTypes';
import { Button, TextField } from "@mui/material";
import { CopyAll } from "@mui/icons-material";
import { RegionSelect } from "../../../components/MaterialSelects/RegionSelect";
import { DistributorSelect } from "../../../components/MaterialSelects/DistributorSelect";
import { useCampaignContext } from "../../../contexts/campaign-context";
import { AreaBookingZone } from "../../../components/MaterialSelects/AreaBookingZone";
import { uniqueId } from "../../../utils";

type AreaBookingRowProps = {
  regionTypeId?: any;
  pricingData?: any;
};

function newRow(): AreaBookingItem {
  return ({
    id: uniqueId(),
    quantity_distributed: null,
    distributor: null,
    deal_price: null,
    date_up: null,
    date_down: null,
    notes: '',
    is_received: false,
    campaignComponent: {
      id: uniqueId(),
      region: null,
      qty: 0
    }
  });
}

const changeUp = (evt, props) => {
  props.field.setValue(props.rowName + '.date_down', format(addWeeks(parse(evt.target.value, 'yyyy-MM-dd', new Date(-1)), 2), 'yyyy-MM-dd'));
  props.field.onChange(evt);
}

const makeColumns = (splitAmounts: boolean, isReadOnly, areaBookingPricing, doCopy, isFringebook: boolean) => {
  let columns: FieldTableColumnProps<AreaBookingItem, AreaBookingRowProps>[] = [
    {
      header: 'Region',
      accessor: 'campaignComponent.region',
      sort: 'campaignComponent.region.name',
      dataType: 'select',
      readOnly: () => {
        return splitAmounts && isReadOnly(true);
      },
      options: {
        // eslint-disable-next-line react/prop-types, react/display-name
        renderEditor: ({ field, row, rowProps, setValue, rowName }) =>
          <RegionSelect retainItemProps={true} areaOnly={true} regionType={rowProps?.regionTypeId} {...field} autoFocus={true}
            onChange={(evt) => {
              console.log('ABSIAUTOSET', 0);
              field.onChange(evt);
              const targetValue = evt.target.value;
              if (!targetValue) return;
              if (targetValue.manual_area_booking_pricing) return;
              // only do this in some types?
              const value = rowProps?.pricingData?.find((row) => row?.region?.id == targetValue?.id);
              console.log('CRC', row, value, rowProps?.pricingData, value, rowName, value?.currency);
              setValue(rowName + '.campaignComponent.currency', value?.currency);
              setValue(rowName + '.campaignComponent.unit_value_prescribed_local', value?.unit_value ?? 0);
              console.log('CRCset', value?.currency, value?.unit_value ?? 0);
            }}
          />,
        label: 'name',

      }
      //      renderer: ({ field }) => field.value?.name
    }
  ];
  if (splitAmounts) {
    const tempColumns: FieldTableColumnProps<AreaBookingItem, AreaBookingRowProps>[] = [
      {
        header: 'Posters Per Site',
        accessor: 'qty_posters_per_site',
        dataType: 'number',
        readOnly: () => {
          return isReadOnly(true);
        }
      }, {
        header: 'Sites',
        accessor: 'qty_sites',
        dataType: 'number',
        readOnly: () => {
          return isReadOnly(true);
        }
      }, {
        header: 'Unit Value',
        readOnly: ({ row }) => {
          return isReadOnly(true) || !row.campaignComponent?.region?.manual_area_booking_pricing;
        },
        dataType: 'currency',
        accessor: 'campaignComponent.unit_value_prescribed_local',
        options: {
          currency: {
            accessor: 'campaignComponent.currency',
          }
        }
      }, {
        header: 'Duration UV',
        dataType: 'currency',
        readOnly: true,
        options: {
          getValue: ({ row }) => {
            return areaBookingPricing(row);
          },
          currency: {
            accessor: 'campaignComponent.currency',
          }
        },
        accessor: 'campaignComponent.unit_value_local'
      }, {
        header: 'Total Value',
        dataType: 'currency',
        readOnly: true,
        options: {
          getValue: ({ row }) => {
            return areaBookingPricing(row) * row.qty_posters_per_site * row.qty_sites;
          },
          currency: {
            accessor: 'campaignComponent.currency',
          }
        },
        accessor: 'campaignComponent.value'
      }, {
        // the total shown in the regionType row uses a single currency... so convert beforehand
        header: 'Total Quote Value',
        hideWhen: () => false,
        dataType: 'currency',
        readOnly: true,
        accessor: 'campaignComponent.quote_value',
        options: {
          getValue: ({ row, calcExchangeRate }) => {
            console.log('calcER1', row.campaignComponent.currency, (areaBookingPricing(row), row.qty_posters_per_site * row.qty_sites),
              calcExchangeRate(row.campaignComponent.currency, (areaBookingPricing(row), row.qty_posters_per_site * row.qty_sites))
            );
            return calcExchangeRate(row.campaignComponent.currency, areaBookingPricing(row), row.qty_posters_per_site * row.qty_sites)
          }
        }
      }
    ];
    columns = columns.concat(tempColumns);
  } else {
    if (isFringebook) {
      columns.push({
        header: 'Zone', accessor: 'areaBookingZone',
        dataType: 'select',
        width: 'minmax(10em, max-content)',
        options: {
          label: 'name',
          renderEditor: ({ field }) => <AreaBookingZone {...field} />
        }
      });
    }

    columns.push({
      header: 'Amount',
      accessor: 'campaignComponent.qty',
      dataType: 'number'
    });
  }
  const columns2: FieldTableColumnProps<AreaBookingItem, AreaBookingRowProps>[] = [
    {
      header: 'Distributor', accessor: 'distributor',
      dataType: 'select',
      width: 'minmax(6em, max-content)',
      options: {
        label: 'name',
        renderEditor: ({ field }) => <DistributorSelect {...field} />
      }
    },
    {
      header: 'Date Up', accessor: 'date_up',
      dataType: 'date',
      readOnly: () => {
        return isReadOnly(true);
      },
      options: {
        onChange: changeUp
      }
    },
    {
      header: 'Date Down',
      accessor: 'date_down',
      dataType: 'date',
      readOnly: () => {
        return isReadOnly(true);
      }
      //      renderer: ({ field }) => <span>{isoDateToMMM(field.value)}</span>,
      //editor: ({ field }) => <IsoDatePicker {...field} autoFocus={true} />
    },
    {
      header: 'Recvd',
      accessor: 'is_received',
      dataType: 'boolean',
      width: 'minmax(3em, max-content)'
      // eslint-disable-next-line react/prop-types, react/display-name
      //renderer: ({ field }) => (
      //field.raw?(field.value?'Y':'N'):<Button className="uneditable" icon={field.value ? 'tick' : 'blank'} onClick={clickableField(field)} />
      //),
      // eslint-disable-next-line react/prop-types, react/display-name
      //editor: ({ field }) => <Button className="uneditable" icon={field.value ? 'tick' : 'blank'} autoFocus={true} onClick={clickableField(field)} />
    },
    {
      header: '',
      accessor: 'copy-id',
      dataType: 'boolean',
      readOnly: true,
      width: 'minmax(2em, max-content)',
      options: {
        renderViewer: ({ field, row }) => {
          return field.readOnly ? [] : <Button data-id={row.id} size="small" title="Copy these dates to all other entries" onClick={doCopy} startIcon={<CopyAll />}></Button>;
        }
      }
    }];
  return columns.concat(...columns2);
}

const AreaBookingItems = ({ row, splitAmounts, hasRegionalPricing, name, values, setValue, onChange, errors, loading, readOnly, isReadOnly, config }) => {
  //var region_type_id = props.values.regionType.id;
  // const daybook = useDaybookContext();
  const campaignContext = useCampaignContext();
  //const pricingPerRegion = daybook?.regionAreaBookingPricing;
  const pricingQuery = useGetAreaBookingRegionPricingsQuery({ variables: { poster_size_id: row?.posterSize?.id }, skip: !hasRegionalPricing || !row?.posterSize?.id });

  const [renderedPosterSize, setRenderedPosterSize] = React.useState(row?.posterSize?.id);
  // with per-region pricing:
  // - when the posterSize changes
  // - recalculate the pricing of all child nodes
  React.useEffect(() => {
    console.log('ABI0 trigger', row, pricingQuery.data, values?.areaBookingItems);
    if (!hasRegionalPricing) return;
    if (renderedPosterSize == row?.posterSize?.id) return;
    if (pricingQuery.data && values?.areaBookingItems) {
      setRenderedPosterSize(row?.posterSize?.id);
      console.log('ABI0 trigger 2', pricingQuery.data, values?.areaBookingItems, renderedPosterSize);
      values.areaBookingItems.forEach((value, idx) => {
        const regionId = value.campaignComponent?.region?.id;
        console.log('ABI0 trigger 3', regionId, value.campaignComponent?.region?.manual_area_booking_pricing, hasRegionalPricing);
        if (!regionId) return;
        if (value.campaignComponent?.region?.manual_area_booking_pricing) return;
        const price = pricingQuery?.data?.getAreaBookingRegionPricings?.find((v) => v?.region?.id == regionId);
        console.log('ABI0 trigger 4', price, pricingQuery.data, values?.areaBookingItems);
        if (!price) {
          setValue(name + '.areaBookingItems[' + idx + '].campaignComponent.currency', null);
          setValue(name + '.areaBookingItems[' + idx + '].campaignComponent.unit_value_prescribed_local', 0);
        } else {
          setValue(name + '.areaBookingItems[' + idx + '].campaignComponent.currency', price.currency);
          setValue(name + '.areaBookingItems[' + idx + '].campaignComponent.unit_value_prescribed_local', price.unit_value);
        }
      });
    }
  }, [pricingQuery.data, row?.posterSize?.id]);

  const [columns, setColumns] = React.useState<FieldTableColumnProps<AreaBookingItem, AreaBookingRowProps>[]>([]
  );
  const doCopy = React.useCallback((evt) => {
    //console.log('click','name is',name,evt.target.closest('[data-id]').dataset.id);
    const id = evt.target.closest('[data-id]').dataset.id;
    setValue(name + '.areaBookingItems', (value) => {
      let selRow = null;
      value.forEach((row) => {
        console.log('look for', id, 'in', row);
        if (row.id == id) {
          selRow = row;
        }
      });
      if (!selRow) return value;
      value.forEach((row) => {
        if (row.id != id) {
          row.date_up = selRow?.date_up;
          row.date_down = selRow?.date_down;
        }
      })
      return [...value];
    })
  }, [values.areaBookingItems?.length, name]);
  React.useEffect(() => {
    setColumns(makeColumns(splitAmounts, isReadOnly, campaignContext.calculateAreaPricing, doCopy, !!config?.isFringebook));
  }, [campaignContext.calculateAreaPricing, splitAmounts, isReadOnly, doCopy, config?.isFringebook]);

  const getRowProps = React.useCallback(() => {
    return { regionTypeId: values?.regionType?.id, pricingData: pricingQuery?.data?.getAreaBookingRegionPricings };
  }, [values?.regionType?.id, pricingQuery?.data?.getAreaBookingRegionPricings]);
  if (!values.regionType?.id) {
    return <div className="area-booking__area-booking-items subtable-holder"><h3>Please select Region Type before adding child rows</h3></div>;
  }
  const allowAddDelete = !(readOnly || isReadOnly(true));
  return (
    <div className="area-booking__area-booking-items subtable-holder">
      <div className="grid12">
        <TextField sx={{ marginTop: 0, marginBottom: 0 }} fullWidth={true} name={name + '.special_instructions'} label="Special Instructions" multiline={true}
          onChange={onChange} value={values.special_instructions ?? ''} disabled={readOnly} />
      </div>
      <FieldTable columns={columns}
        newRow={newRow}
        className="campaigns__area-bookings__items"
        values={values?.areaBookingItems || []}
        setValue={setValue}
        errors={errors}
        newRowLabel={allowAddDelete ? "Add Poster Booking" : ''}
        noRowsLabel="No Poster Bookings"
        noRowsLength={2}
        name={name + '.areaBookingItems'}
        loading={loading}
        hasDelete={allowAddDelete}
        getRowProps={getRowProps}
        hasExport={false}
        readOnly={readOnly}
      />
    </div>);
};

AreaBookingItems.propTypes = {
  name: PropTypes.string,
  values: PropTypes.object,
  setValue: PropTypes.func,
  onChange: PropTypes.func
}

export default AreaBookingItems;
